export default __webpack_public_path__ + "static/media/974.f1f54ca0.pdf";